var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 3H10.5C6.35786 3 3 6.35786 3 10.5V25.5C3 29.6421 6.35786 33 10.5 33H25.5C29.6421 33 33 29.6421 33 25.5V10.5C33 6.35786 29.6421 3 25.5 3Z",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17.0555C24.1852 18.3038 23.9719 19.5788 23.3907 20.699C22.8094 21.8192 21.8898 22.7276 20.7625 23.295C19.6352 23.8624 18.3577 24.0598 17.1117 23.8594C15.8657 23.6589 14.7147 23.0706 13.8223 22.1782C12.9299 21.2858 12.3416 20.1348 12.1412 18.8888C11.9407 17.6428 12.1381 16.3653 12.7055 15.238C13.2729 14.1107 14.1813 13.1911 15.3015 12.6098C16.4217 12.0286 17.6967 11.8153 18.945 12.0005C20.2184 12.1893 21.3973 12.7826 22.3076 13.6929C23.2179 14.6032 23.8112 15.7821 24 17.0555Z",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 9.75H26.2657",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.f51a9b7ed13645c6fcd160f72c7a0a16.svg";
export { ForwardRef as ReactComponent };